import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return(
        <footer className="footer">
            <div className="container">
                <div className="row">   

                    <div className="col-3 offset-1">
                        <h5>Links</h5>
                        <ul className="list-unstyled">
                            <li><Link to="/home">Home</Link></li>
                            <li><Link to="/aboutus">About Us</Link></li>
                            <li><Link to="/menu">Menu</Link></li>
                            <li><Link to="/contactus">Contact Us</Link></li>
                        </ul>
                    </div>

                    <div className="col-3 offset-1">
                        <h5>Our Address</h5>
                        <address>
                            121, Clear Water Bay Road<br />
                            Clear Water Bay, Kowloon<br />
                            HONG KONG<br />
                            <i className="fa fa-phone fa-lg"></i> +852 1234 5678<br />
                            <i className="fa fa-fax fa-lg"></i> +852 8765 4321<br />
                            <i className="fa fa-envelope fa-lg"></i> <a href="mailto:confusion@food.net">
                                confusion@food.net</a>
                        </address>
                    </div>

                    <div className="col-3 offset-1 align-self-center">
                        <a className="btn btn-social-icon btn-facebook" href="http://www.facebook.com/profile.php?id=">
                            <i className="fa fa-facebook-f"></i>
                        </a>&nbsp;
                        <a className="btn btn-social-icon btn-twitter" href="http://twitter.com/">
                            <i className="fa fa-twitter"></i>
                        </a>&nbsp;
                        <a className="btn btn-social-icon btn-instagram" href="http://instagram.com/">
                            <i className="fa fa-instagram"></i>
                        </a>&nbsp;
                        <a className="btn btn-social-icon btn-google" href="http://youtube.com/">
                            <i className="fa fa-youtube"></i>
                        </a>&nbsp;
                        <a className="btn btn-social-icon btn-vk" href="http://vk.com/">
                            <i className="fa fa-vk"></i>
                        </a>&nbsp;
                        <a className="btn btn-social-icon btn-linkedin" href="http://www.linkedin.com/in/"> 
                            <i className="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>
                <div className="row justify-content-center mt-4">             
                    <div className="col-auto">
                        <p>© Copyright 2020 Ristorante Con Fusion</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/FooterComponent.js